import { createStyledElement } from "../../../../utils/createStyledElement";
import { systemWhite } from "../../constants";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const FooterContainer = createStyledElement("div", () => ({
  width: "100%",
  padding: isMobileViewport() ? "25px 16px" : "25px 40px",
  backgroundColor: "#306BF5",
  borderTop: "1px solid #447FFF",
}));

export const FooterContent = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: isMobileViewport() ? "center" : "flex-start",
  alignItems: isMobileViewport() ? "flex-start" : "center",
  flexDirection: isMobileViewport() ? "column" : "row",
  gap: isMobileViewport() ? 15 : 25,
}));

export const FooterTitle = createStyledElement("div", {
  font: '400 12px/16px "Roboto", sans-serif',
  color: "#ADC6FF",
});

export const FooterLink = createStyledElement("a", {
  font: '400 12px/16px "Roboto", sans-serif',
  textDecoration: "none",
  color: systemWhite,
});
